import { useEffect, useState } from "react";
import axios from "axios";

const useFetch = (url) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchMovies = async () => {
      setLoading(true);
      await axios
        .get(url)
        .then((response) => setData(response.data.results))
        .then(() => setLoading(false))
        .catch((error) => console.log(error.message));
    };
    fetchMovies();
  }, [url]);

  return [data, loading];
};

export default useFetch;
